function AddLinkUnderline() {
    const div1 = document.getElementById("sk-CompareHomeUIDefinition");
    const div2 = document.getElementById("sk-CompareTravelUIDefinition");
    const div3 = document.getElementById("sk-CompareMotorUIDefinition");
    const headerlinkhome = document.querySelector("#main-nav li:nth-child(2)");
    const headerlinktravel = document.querySelector("#main-nav li:nth-child(3)");
    const headerlinkmotor = document.querySelector("#main-nav li:nth-child(1)");

    if ( !headerlinkhome || !headerlinktravel || !headerlinkmotor ) return;
    
    if ( div1 ) {
        headerlinkhome.classList.add('homeclass');
    }
    else if ( div2 ) {
        headerlinktravel.classList.add('travelclass');
    }
    else if ( div3 ) {
        headerlinkmotor.classList.add('carclass');
    }
};

export { AddLinkUnderline };